module.exports = __webpack_public_path__ + "static/img/V-M30@2x.a3d97339.png";